import { defaultParseError, parseString } from "../utils";
/**
 * Date format constant string
 */
export class CharacterConstant {
    constructor(character) {
        this.character = character;
    }
    render() {
        return this.character;
    }
    parse(state) {
        return parseString(state, [this.character], null, defaultParseError(state));
    }
}
//# sourceMappingURL=CharacterConstant.js.map
